import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ILoadingOverlayAngularComp } from 'ag-grid-angular';
import { ILoadingOverlayParams } from 'ag-grid-enterprise';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      @keyframes shine {
        100% {
          mask-position: left;
        }
      }
      img {
        &.shine {
          color: grey;
          display: inline-block;
          mask: linear-gradient(-60deg, #000 30%, #0005, #000 70%) right/350% 100%;
          animation: shine 0.8s infinite;
          font-size: 50px;
          max-width: 200px;
        }
      }
    `,
  ],
  template: ` <img class="shine" src="/assets/images/logo/ts-logo.png" role="presentation" [style]="style" /> `,
})
export class CustomLoadingOverlay implements ILoadingOverlayAngularComp {
  style = { height: 'auto', width: '80px' };

  agInit(params: ILoadingOverlayParams & { size: 'medium' | 'small' }): void {
    this.style = { ...this.style, width: params.size === 'small' ? '40px' : '80px' };
  }
}
